
const tiers = [
  {
    label: "Tier 1: Immigration",
    status: "NOW · LIVE",
    statusColor: "text-green-500",
    dotColor: "bg-green-500",
    points: [
      "Global TAM £24.4B · 5,089 UK firms",
      "Xeni live in UK, AU/NZ partner, SG pipeline",
      "Massively fragmented — owners want to exit",
      "Roll-up ready. Seed round proves the playbook.",
    ],
  },
  {
    label: "Tier 2: Legal Services",
    status: "NEXT",
    statusColor: "text-orange-500",
    dotColor: "bg-orange-500",
    points: [
      "Global market £1.1T · UK £55B",
      "Conveyancing, probate, family law, employment",
      "Same playbook: acquire small firms, deploy COSX, transform margins",
      "PE drives 31% of legal M&A — consolidation accelerating",
    ],
  },
  {
    label: "Tier 3: All Regulated",
    status: "SCALE",
    statusColor: "text-[#818cf8]",
    dotColor: "bg-[#818cf8]",
    points: [
      "Global market £3T+ · UK £150B",
      "Financial advisory, accounting, insurance, education",
      "Every vertical = new COSX skill",
      "Robolab X already in education — cross-vertical proof",
    ],
  },
];

export function BiggerPictureSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-3 max-w-3xl">
        <h2 className="text-[32px] font-light tracking-tight mb-2 font-[family-name:var(--font-heading)]">
          Immigration is the beachhead
        </h2>
        <p className="text-[14px] leading-relaxed text-[var(--color-fg-secondary)] font-light">
          The same AI roll-up playbook applies across every regulated professional service.<br />
          Immigration proves the model. Then we expand.
        </p>
      </div>

      <div className="flex flex-row gap-6 flex-grow mb-2 -mt-2">
        {/* Left: tier list */}
        <div className="flex-1 pl-5 pt-6">
          <div className="flex flex-col gap-5">
            {tiers.map((t, i) => (
              <div key={t.label} className="relative">
                <div className={`absolute left-[-17px] top-[4px] w-2.5 h-2.5 rounded-full shrink-0 z-[1] ${t.dotColor}`} />
                {i < tiers.length - 1 && <div className="absolute left-[-13px] top-[14px] bottom-[-24px] w-px bg-[var(--color-border)]" />}
                <h3 className="text-[12px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] mb-1.5">
                  <span className="text-[var(--color-fg)]">{t.label}</span> — <span className={t.statusColor}>{t.status}</span>
                </h3>
                <ul className="flex flex-wrap gap-x-4 gap-y-0.5">
                  {t.points.map((p) => (
                    <li key={p} className="flex items-center gap-1.5 text-[12px] text-[var(--color-fg-secondary)] leading-snug">
                      <span className="w-1 h-1 rounded-full bg-[var(--color-fg-tertiary)] shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Right: concentric circles visualization */}
        <div className="w-[38%] flex flex-col items-center justify-start relative -mt-8">
          <div className="relative" style={{ width: 340, height: 340 }}>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center pt-[12%]"
              style={{ width: 340, height: 340, background: "rgba(165, 180, 252, 0.4)" }}
            >
              <span className="text-[11px] opacity-90 mb-1 text-white">Regulated Services</span>
              <span className="text-[24px] font-medium text-white font-[family-name:var(--font-heading)]">£3T+</span>
            </div>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center pt-[9%]"
              style={{ width: 230, height: 230, background: "rgba(129, 140, 248, 0.6)", zIndex: 2 }}
            >
              <span className="text-[11px] opacity-90 mb-1 text-white">Legal Services</span>
              <span className="text-[20px] font-medium text-white font-[family-name:var(--font-heading)]">£1.1T</span>
            </div>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center justify-center"
              style={{ width: 140, height: 140, background: "rgba(99, 102, 241, 0.9)", zIndex: 3 }}
            >
              <span className="text-[10px] opacity-90 mb-0.5 text-white">Immigration</span>
              <span className="text-[16px] font-medium text-white font-[family-name:var(--font-heading)]">£24.4B</span>
            </div>
          </div>

        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Immigration <strong className="text-[var(--color-fg)] font-medium">£24.4B</strong> → Legal <strong className="text-[var(--color-fg)] font-medium">£1.1T</strong> → All regulated professional services <strong className="text-[var(--color-fg)] font-medium">£3T+</strong>
        </p>
      </div>
    </div>
  );
}
